import React, { useState, useEffect } from 'react';
import QRCode from 'qrcode';

const QRCodeHighQuality = ({ uniqueId, size = 200, className = "" }) => {
  const [qrCodeDataURL, setQrCodeDataURL] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const generateQRCode = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // إنشاء رابط الاسترداد
        const redemptionUrl = `https://evouchers.app/scan?key=${uniqueId}`;
        
        // إعدادات QR Code عالية الجودة
        const options = {
          width: size,
          margin: 2,
          color: {
            dark: '#000000',  // لون المربعات السوداء
            light: '#FFFFFF'  // لون الخلفية البيضاء
          },
          errorCorrectionLevel: 'H', // أعلى مستوى تصحيح أخطاء
          type: 'image/png',
          quality: 1.0,
          rendererOpts: {
            quality: 1.0
          }
        };

        // إنشاء QR Code
        const dataURL = await QRCode.toDataURL(redemptionUrl, options);
        setQrCodeDataURL(dataURL);
        setLoading(false);
      } catch (err) {
        console.error('Error generating QR code:', err);
        setError('فشل في إنشاء QR Code');
        setLoading(false);
      }
    };

    if (uniqueId) {
      generateQRCode();
    }
  }, [uniqueId, size]);

  if (loading) {
    return (
      <div className={`flex flex-col items-center space-y-2 ${className}`}>
        <div 
          className="border-2 border-gray-300 rounded bg-gray-100 p-4 flex items-center justify-center"
          style={{ width: size, height: size }}
        >
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        </div>
        <p className="text-xs text-gray-500">جاري إنشاء QR Code...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className={`flex flex-col items-center space-y-2 ${className}`}>
        <div 
          className="border-2 border-red-300 rounded bg-red-50 p-4 flex items-center justify-center"
          style={{ width: size, height: size }}
        >
          <p className="text-red-600 text-sm text-center">{error}</p>
        </div>
        <p className="text-xs text-gray-500 font-mono break-all max-w-48">
          {uniqueId}
        </p>
      </div>
    );
  }

  return (
    <div className={`flex flex-col items-center space-y-3 ${className}`}>
      {/* QR Code Container */}
      <div 
        className="border-2 border-gray-300 rounded-lg bg-white p-3 shadow-sm"
        style={{ width: size + 20, height: size + 20 }}
      >
        <img 
          src={qrCodeDataURL} 
          alt={`QR Code for ${uniqueId}`}
          className="w-full h-full object-contain"
          style={{ 
            imageRendering: 'crisp-edges',
            imageRendering: '-webkit-optimize-contrast'
          }}
        />
      </div>
      
      {/* Unique ID Display */}
      <div className="text-center space-y-1">
        <p className="text-xs text-gray-600 font-medium">المعرف الفريد:</p>
        <p className="text-xs text-gray-800 font-mono break-all max-w-48 bg-gray-100 px-2 py-1 rounded">
          {uniqueId}
        </p>
      </div>
      
      {/* Redemption Link */}
      <div className="text-center space-y-1">
        <p className="text-xs text-gray-600 font-medium">رابط الاسترداد:</p>
        <p className="text-xs text-blue-600 font-mono break-all max-w-48 bg-blue-50 px-2 py-1 rounded">
          https://evouchers.app/scan?key={uniqueId}
        </p>
      </div>
    </div>
  );
};

export default QRCodeHighQuality;
